module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./PolarChart.js"));
	}, "PolarChart");
}